import { render, staticRenderFns } from "./TifTurnoOdo.vue?vue&type=template&id=47d2d984"
import script from "./TifTurnoOdo.vue?vue&type=script&lang=js"
export * from "./TifTurnoOdo.vue?vue&type=script&lang=js"
import style0 from "./TifTurnoOdo.vue?vue&type=style&index=0&id=47d2d984&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports